interface singleFeature {
  imgUrl: string;
  text: string;
}
export const OneCardfeaturelist: Array<singleFeature> = [
  {
    imgUrl:
      'https://www.getonecard.app/images/icons/inapp_controls_landicon.svg',
    text: 'In-App Controls',
  },
  {
    imgUrl:
      'https://www.getonecard.app/assets/apply/zero_fees_carousel.svg',
    text: 'Zero Annual & Joining Fees',
  },
  {
    imgUrl:
      'https://www.getonecard.app/assets/apply/no_cost_emi_carousel.svg',
    text: 'No Cost EMI',
  },
  {
    imgUrl:
      'https://www.getonecard.app/assets/apply/rewards_carousel.svg',
    text: '5x Rewards',
  },
];
